/* eslint-disable react-hooks/exhaustive-deps */
import { FormControl, FormHelperText, InputLabel, TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Paper from "@material-ui/core/Paper";

import getList from "../../../lib/api/getList";
import getNewDateObj from "../../../lib/common/getNewDateObj";


const CustomPaper = (props) => {

    return <Paper square={true} {...props} />;

};
/**
 * @COMPONENT_NAME FormItemAutoComplete
 * @DESCRIPTION 자동완성 기능이 포함된 입력 컴포넌트로, 지정된 테이블로부터 데이터를 불러와 자동완성 리스트를 구성합니다.
 *              다양한 옵션(여러 컬럼 조합, 괄호 표시, 날짜 처리 등)을 지원하며, 선택 항목 변경 시 상위로 값을 전달합니다.
 * @PROPS
 *    - {string} id - 컴포넌트 고유 ID (label 연결 등)
 *    - {string} className - CSS 클래스 이름
 *    - {object} column - 자동완성 동작을 제어하는 구성 정보 (codeInfo, required, displayEmpty 등 포함)
 *    - {string} label - 입력 필드 라벨 텍스트
 *    - {string} helperText - 입력 하단에 표시될 설명 텍스트
 *    - {object} InputLabelProps - MUI InputLabel에 전달할 props
 *    - {Function} onChange - 항목 선택 시 호출되는 콜백 (선택된 항목의 value 값 전달)
 *    - {...object} others - 기타 추가 전달되는 props (FormControl, Autocomplete 등에 전달됨)
 *
 * @PASSTHROUGH_PROPS
 *    - {boolean} autoFocus - TextField에 자동 포커스를 줄지 여부
 *    - {object} inputProps - TextField의 inputProps (예: tabIndex 등)
 *
 * @CALLBACKS
 *    - {Function} onChange - 자동완성 항목 선택 시 호출되며, 선택된 value를 인자로 전달.
 *
 */
function FormItemAutoComplete(props) {

    const { t } = useTranslation();

    const { id, className, column, label, helperText, InputLabelProps, onChange, ...others } = props;
    const [selectItems, setSelectItems] = useState([]);

    useEffect(() => {

        let mounted = true;

        (async () => {

            const codeInfo = column.codeInfo;

            try {

                let apiResult = await getList(codeInfo.tableName);

                if (mounted) {

                    let selectItems = apiResult.data.map((result) => {

                        if (Array.isArray(codeInfo.nameColumn)) {

                            let name = "";
                            let first = true;
                            let colIndex = 0;

                            for (const columnName of codeInfo.nameColumn) {

                                if (codeInfo.nameColumnType?.[columnName]?.startsWith("date")) {
                                    result[columnName] = getNewDateObj(String(result[columnName]));
                                }

                                if (codeInfo.useParenthesis) {

                                    if (codeInfo.useParenthesis[colIndex]) {

                                        if (result[columnName]) {

                                            name += codeInfo.openParenthesis;
                                            name += result[columnName];
                                            name += codeInfo.closeParenthesis;

                                        } else {

                                            name += "";

                                        }

                                    } else {

                                        if (!first && result[columnName]) {

                                            name += (codeInfo.seperator || ", ");

                                        }

                                        first = false;
                                        name += result[columnName] || "";

                                    }

                                } else {

                                    if (!first && result[columnName]) {

                                        name += (codeInfo.seperator || ", ");

                                    }

                                    first = false;
                                    name += result[columnName] || "";

                                }

                                colIndex++;

                            }

                            return { name: name, value: result[codeInfo.valueColumn] };

                        } else {

                            if (codeInfo.nameColumnType?.[codeInfo.nameColumn]?.startsWith("date")) {
                                result[codeInfo.nameColumn] = getNewDateObj(String(result[codeInfo.nameColumn]));
                            }

                            return { name: result[codeInfo.nameColumn], value: result[codeInfo.valueColumn] };

                        }

                    });

                    if (codeInfo.sortByName) {

                        selectItems.sort((itemA, itemB) => (('' + itemA.name).localeCompare(itemB.name)))

                    }

                    if (codeInfo.useEmptyValue) {
                        setSelectItems([{ name: t(codeInfo.emptyName), value: codeInfo.specifiedValue?.enabled ? codeInfo.specifiedValue.value : "" }, ...selectItems]);
                    } else {

                        setSelectItems(selectItems);
                    }

                }



            } catch (reason) {

                console.error(`Get Code List from Table "${codeInfo.tableName}" Failed`);

            }

        })();

        return (() => {
            mounted = false;
        });

    }, [column]);

    const selectProps = {
        onChange: (_event, option) => {

            onChange(option ? option.value : "");

        },
        ...others
    };

    if (column.displayEmpty) {

        selectProps.displayEmpty = true;

    }

    if (column.style) {

        selectProps.style = column.style;

    }

    if (column.getOptionDisabled) {

        selectProps.getOptionDisabled = column.getOptionDisabled;

    }

    return (
        <FormControl className={className} required={column.required} style = {column.formStyle} {...others} >
            <InputLabel
                id={id + "-label"}
                shrink={true}
                {...InputLabelProps}
            >
                {label}
            </InputLabel>
            <Autocomplete
                id={id}
                style={{ paddingTop: "16px" }}
                PaperComponent={CustomPaper}
                {...selectProps}
                options={selectItems}
                getOptionLabel={(option) => (option.name)}
                autoSelect={true}
                renderInput={(params) => {
                    const inputProps = params.inputProps;
                    inputProps.autoComplete = "chrome-off";
                    return <TextField {...params} autoFocus={props.autoFocus} inputProps={inputProps} />
                }}
                tabIndex={props.inputProps?.tabIndex}
                // 기본값 숫자 1 과 목록 값 "1"(bigint 는 문자열로 온다)처럼 꼴만 다른 값도 같은 항목으로 보인다 — 전에는 값이 있는데 칸이 비어 보였다
                value={selectItems.length > 0 ? selectItems.find((item) => item.value === selectProps.value || ( selectProps.value !== "" && selectProps.value != null && String(item.value) === String(selectProps.value) )) : { name: "", value: "" }}
            />

            <FormHelperText>{helperText}</FormHelperText>
        </FormControl>
    );

}

export default FormItemAutoComplete;
